<template>
    <section class="home-page">
        <VueSlickCarousel v-if="hasSlider" v-bind="carouselSettings">
            <div
                v-for="(slide, index) in resolvedSlides"
                :key="index"
                class="hero-slide-container-new"
            >
                <img
                    v-if="slide.heroImg"
                    :src="slide.heroImg"
                    :alt="slide.title || ''"
                    class="hero-image"
                />
                <div class="overlay"></div>
                <div class="hero-text">
                    <h1 class="font-medium">{{ slide.title }}</h1>
                    <p v-if="slide.paragraph" class="text-lg mt-4 md:mt-6">
                        {{ slide.paragraph }}
                    </p>
                </div>
            </div>
        </VueSlickCarousel>

        <div v-else class="hero-slide-container-new">
            <img
                v-if="resolvedSlides[0].heroImg"
                :src="resolvedSlides[0].heroImg"
                :alt="resolvedSlides[0].title || ''"
                class="hero-image"
            />
            <div class="overlay"></div>
            <div class="hero-text pl-[4vw]">
                <h1 class="font-medium">
                    {{ resolvedSlides[0].title }}
                </h1>
                <p
                    v-if="resolvedSlides[0].paragraph"
                    class="text-lg mt-4 md:mt-6"
                >
                    {{ resolvedSlides[0].paragraph }}
                </p>
            </div>
        </div>
    </section>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
    name: "HomeHero",
    components: { VueSlickCarousel },
    props: {
        title: {
            type: String,
            required: false,
            default: "Page Title",
        },
        heroImg: {
            type: String,
            required: false,
            default: "",
        },
        paragraph: {
            type: String,
            required: false,
            default: "",
        },
        // Optional list of { title, paragraph, heroImg } to enable multi-slide mode.
        slides: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    computed: {
        resolvedSlides() {
            if (this.slides && this.slides.length) return this.slides;
            return [
                {
                    title: this.title,
                    paragraph: this.paragraph,
                    heroImg: this.heroImg,
                },
            ];
        },
        hasSlider() {
            return this.resolvedSlides.length > 1;
        },
        carouselSettings() {
            const many = this.resolvedSlides.length > 1;
            return {
                dots: many,
                dotsClass: "slick-dots custom-dot-class",
                arrows: many,
                edgeFriction: 0.35,
                infinite: many,
                speed: 500,
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
            };
        },
    },
};
</script>

<style scoped lang="scss">
@use "../../../sass/utilities/media" as media;

// -----------------------------------------------------------------------------
// Hero slide container
// Ported from resources/sass/pages/_home.scss and refactored mobile-first to
// use the design-system breakpoints (sm 640, md 768, lg 1024, xl 1280).
// -----------------------------------------------------------------------------
.hero-slide-container-new {
    position: relative;
    display: flex !important;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;

    color: #fff;
    margin: 0 auto;
    max-width: 100%;
    overflow: hidden;

    // Mobile first
    height: 60vh;
    min-height: 260px;
    padding: 1.5rem 1rem;

    @include media.screen-up("sm") {
        padding: 1.75rem 1.5rem;
        height: 80vh;
    }

    .hero-image {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 0;
        object-position: 60% 0%;
    }

    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            90deg,
            rgba(0, 0, 0, 0.6) 100%,
            rgba(0, 0, 0, 0.2) 100%
        );
        z-index: 1;
        pointer-events: none;

        @include media.screen-up("md") {
            background: linear-gradient(
                90deg,
                rgba(0, 0, 0, 1) 0%,
                rgba(0, 0, 0, 0) 100%
            );
        }
    }

    a {
        color: #fff;
        text-decoration: none;
    }

    .hero-text {
        position: relative;
        z-index: 2;
        display: flex;
        flex-flow: column wrap;
        justify-content: flex-start;
        align-items: flex-start;
        align-self: center;
        width: 100%;

        @include media.screen-up("md") {
            max-width: 45%;

            h1 {
                font-size: clamp(1rem, 4vw, 6rem);
            }
        }
    }
}
</style>
